import ReraVerifiedImg from "../../../assets-user/RERAVarified.svg";

const ContactUs = () => {

  return (
    <div className="w-full border rounded-lg">
      
      <div className="mx-auto p-4 md:6 lg:p-8 bg-white rounded-xl">
        {/* Header Section */}
        <div className="mb-6 sm:mb-7 md:mb-8" data-aos="fade-down">
          <h2 className="text-base sm:text-lg md:text-2xl lg:text-3xl font-semibold mb-1 sm:mb-2 md:mb-3 text-gray-900">
            Contact
          </h2>
          <p className="text-xs sm:text-sm md:text-base lg:text-lg font-normal text-gray-600">
            To get more benefits and end-to-end support, contact the verified
            Agent for this Property.
          </p>
        </div>

        {/* Divider */}
        <div
          className="border-t border-gray-200 mb-4 sm:mb-5 md:mb-6"
          data-aos="fade-up"
          data-aos-delay="100"
        ></div>

        {/* Agent Info Section */}
        <div
          className="mb-5 sm:mb-6 md:mb-8"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="flex flex-wrap items-center gap-2 sm:gap-3 md:gap-4 mb-2 sm:mb-3 md:mb-4">
            <h2 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-900">
              P S Goyal
            </h2>
            <div
              className="w-12 sm:w-14 md:w-16"
              data-aos="flip-left"
              data-aos-delay="300"
            >
              <img
                src={ReraVerifiedImg}
                alt="RERA Verified"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          <p className="text-gray-500 text-sm sm:text-base md:text-lg font-normal">
            +91- 738XXXXXXX
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3 sm:space-y-4">
          <button
            className="w-full py-2.5 sm:py-3 md:py-4 px-4 sm:px-5 md:px-6 border-2 border-red-500 text-red-500 rounded-2xl font-semibold text-sm sm:text-base md:text-lg hover:bg-red-50 transition-colors"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            View Profile
          </button>
          <button
            className="w-full py-2.5 sm:py-3 md:py-4 px-4 sm:px-5 md:px-6 bg-red-500 text-white rounded-2xl font-semibold text-sm sm:text-base md:text-lg hover:bg-red-600 transition-colors"
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            Get Phone No.
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
